// @flow
export const TOGGLE_INITIAL_MOUNT: string = 'TOGGLE_INITIAL_MOUNT'
export const CHANGE_ACTIVE_SORT: string = 'CHANGE_ACTIVE_SORT'
export const CHANGE_ERROR_STATE: string = 'CHANGE_ERROR_STATE'



// WEBPACK FOOTER //
// ./src/shared/actionTypes/parametersTypes.js